<template>
  <div>
    <Drawer
      :title="changeModalTitle"
      v-model="changeModal"
      width="550"
      :mask-closable="true"
      @on-close="changeModalCancel"
      class="heart-config-page">
      <div>
        <Form ref="changeForm" :model="changeForm" :label-width="80" :rules="changeRule">
          <FormItem label="名称" prop="name">
            <Input v-model="changeForm.name" />
          </FormItem>
          <FormItem label="设备选择" prop="obj_type">
            <Select v-model="changeForm.obj_type">
              <Option value="group" key="group">设备组</Option>
              <Option value="host" key="host">设备</Option>
            </Select>
          </FormItem>
          <FormItem label="设备组" prop="obj_group" v-if="changeForm.obj_type === 'group'">
            <Select v-model="obj_group" multiple>
              <Option v-for="item in endpointGroupList" :value="item.grp_name" :key="item.grp_name">{{ item.grp_name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="设备" prop="obj_host" v-if="changeForm.obj_type === 'host'">
            <Select v-model="obj_host" multiple>
              <Option v-for="item in endpointList" :value="item.endpoint" :key="item.endpoint">{{ item.endpoint }}</Option>
            </Select>
          </FormItem>
          <FormItem label="指标" prop="metric">
            <Input v-model="changeForm.metric" placeholder="如：cpu.system" />
          </FormItem>
          <FormItem label="标签" prop="tags">
            <Input placeholder="如：idc=shenzhen,module=nodata" v-model="changeForm.tags" />
          </FormItem>
          <FormItem label="类型" prop="dstype">
            <Select v-model="changeForm.dstype">
              <Option value="GAUGE" key="GAUGE">GAUGE</Option>
            </Select>
          </FormItem>
          <FormItem label="周期" prop="step">
            <InputNumber :min="0" v-model="changeForm.step"/>
          </FormItem>
          <FormItem label="数据缺少时，补发值" prop="mock">
            <InputNumber v-model="changeForm.mock"/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
    <Card shadow>
      <Row>
        <Col>
          <Button
            style="float: right;"
            @click="changeModal = true; changeModalTitle='添加配置'"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">添加配置</Button>
        </Col>
      </Row>
      <Table
        border
        :loading="changeTableLoading"
        :data="table.data"
        :columns="table.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudHeartConfig, changePrivateCloudHeartConfig, deletePrivateCloudHeartConfig,
  getAllEndpoint, getAllAlarmAllHostGroup } from '@/api/monitor'

export default {
  name: 'heart-config',
  data () {
    return {
      changeModal: false,
      changeTableLoading: false,
      changeModalTitle: '添加服务商',
      changeForm: {
        id: 0,
        name: '',
        obj_type: 'group',
        obj: '',
        metric: '',
        tags: '',
        dstype: 'GAUGE',
        step: 60,
        mock: -1
      },
      obj_group: [],
      obj_host: [],
      endpointList: [],
      endpointGroupList: [],
      changeRule: {
        name: { required: true, message: '名称不能为空', trigger: 'blur' },
        obj_group: { required: true, validator: this.validObjGroupRule, message: '请选择设备组', trigger: 'change' },
        obj_host: { required: true, validator: this.validObjHostRule, message: '请选择设备', trigger: 'change' },
        metric: { required: true, message: '指标不能为空', trigger: 'blur' },
        dstype: { required: true, message: '请选择类型', trigger: 'change' },
        step: { required: true, validator: this.validNumberRule, message: '周期不能为空', trigger: 'blur' },
        mock: { required: true, validator: this.validNumberRule, message: '补发值不能为空', trigger: 'blur' }
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            key: 'name',
            align: 'center',
            minWidth: 150
          },
          {
            title: '设备组/设备',
            align: 'center',
            minWidth: 110,
            render: (h, params) => {
              let result = ''
              if (params.row.obj_type === 'group') {
                result = '设备组'
              } else if (params.row.obj_type === 'host') {
                result = '设备'
              }
              return h('span', result)
            }
          },
          {
            title: '设备组名/设备名',
            key: 'obj',
            align: 'center',
            minWidth: 150
          },
          {
            title: '指标',
            key: 'metric',
            align: 'center',
            minWidth: 130
          },
          {
            title: '标签',
            key: 'tags',
            align: 'center',
            minWidth: 80
          },
          {
            title: '类型',
            key: 'dstype',
            align: 'center',
            minWidth: 100
          },
          {
            title: '周期',
            key: 'step',
            align: 'center',
            minWidth: 70
          },
          {
            title: '补发值',
            key: 'mock',
            align: 'center',
            minWidth: 80
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 90,
            render: (h, params) => {
              return h('div', [
                // h('Button', {
                //   style: {
                //     marginRight: '5px'
                //   },
                //   props: {
                //     type: 'warning',
                //     size: 'small'
                //   },
                //   on: {
                //     click: () => {
                //       this.changeModifyOpen(params.row)
                //     }
                //   }
                // }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      }
    }
  },
  mounted: function () {
    this.getTableData()
    this.getEndpointList()
    this.getAllHostGroup()
  },
  methods: {
    changeModalCancel () {
      this.formReset('changeForm')
      this.changeModal = false
    },
    formReset (name) {
      this.$refs[name].resetFields()
    },
    changeSubmit () {
      if (this.changeForm.obj_type === 'group') {
        this.changeForm.obj = this.obj_group
      } else {
        this.changeForm.obj = this.obj_host
      }
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          changePrivateCloudHeartConfig(this.changeForm, this.changeForm.id).then(res => {
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getTableData()
              this.formReset('changeForm')
              this.changeModal = false
            } else if (result.code === 417) {
              this.$Notice.error({ title: '该名称已存在！' })
              return false
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
              return false
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getTableData (value = 1) {
      this.table.page = value
      let params = {
        limit: this.table.size,
        page: this.table.page
      }
      getPrivateCloudHeartConfig(params).then(res => {
        this.table.data = res.data.data
        this.table.count = res.data.total
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取服务商列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取服务商列表失败！服务器无响应'
          })
        }
      })
    },
    // changeModifyOpen (row) {
    //   this.changeForm.id = row.id
    //   this.changeForm.name = row.name
    //   this.changeForm.dstype = row.dstype
    //   this.changeForm.tags = row.tags
    //   this.changeForm.step = row.step
    //   this.changeForm.mock = row.mock
    //   this.changeForm.metric = row.metric
    //   this.changeForm.obj_type = row.obj_type
    //   this.changeForm.obj = row.obj
    //   this.changeModalTitle = '「' + row.name + '」 编辑'
    //   this.changeModal = true
    // },
    delete (row) {
      deletePrivateCloudHeartConfig(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getTableData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    getEndpointList () {
      getAllEndpoint().then(res => {
        this.endpointList = res.data
      })
    },
    getAllHostGroup () {
      getAllAlarmAllHostGroup().then(res => {
        this.endpointGroupList = res.data.data
      })
    },
    validObjGroupRule (rule, value, callback) {
      if (this.changeForm.obj_type === 'group') {
        if (this.obj_group.length === 0) {
          callback(new Error())
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validObjHostRule (rule, value, callback) {
      if (this.changeForm.obj_type === 'host') {
        if (this.obj_host.length === 0) {
          callback(new Error())
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validNumberRule (rule, value, callback) {
      if (value === null) {
        callback(new Error())
      } else {
        callback()
      }
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
<style lang="less">
.heart-config-page{
  .ivu-input-number{
    width:100%;
  }
}
</style>
